/**
 * Enables automatic tracking on links and forms.
 * @param {HTMLElement} [context=document.body] - Optional DOM context.
 */
export default function trackingEnhancement(context = document.body) {
	const trackingElements = [
		{ selector: 'a[href^="mailto:"]', label: "Email click" },
		{ selector: 'a[href^="tel:"]', label: "Phone click" }
	];

      // Tag all tracing elements.
	trackingElements.forEach(element => {
    const el = context.querySelector(element.selector),
      label = element.label;
    if (el) el.setAttribute('data-sw-tracker', JSON.stringify({ label }));
	});
}



// WEBPACK FOOTER //
// ./source/scripts/enhancements/tracking.js